import fetch from "auth/FetchInterceptor";

const IndicadoresConfigurationService = {};

IndicadoresConfigurationService.getAll = function (id) {
	return fetch({
		url: `/v1/rest/goals-config/${id}`,
		method: "get",
	});
};

IndicadoresConfigurationService.post = function (data) {
	return fetch({
		url: "/v1/rest/goal-config",
		method: "post",
		data: data,
	});
};

IndicadoresConfigurationService.postCopyGoalConfig = function (data, id) {
	return fetch({
		url: `/v1/rest/goal-config-in-company-schema/${id}`,
		method: "post",
		data: data,
	});
};

// Copia, em lote e numa única transação, todas as colunas (fluxo legado) de
// um indicador para outra empresa. O backend remapeia o totalizator_ref para
// os novos ids da cópia (ver goal-config-resource.js).
IndicadoresConfigurationService.postCopyGoalConfigsBatch = function (
	companyId,
	data,
) {
	return fetch({
		url: `/v1/rest/goal-config-in-company-schema-batch/${companyId}`,
		method: "post",
		data: data,
	});
};

IndicadoresConfigurationService.put = function (id, data) {
	return fetch({
		url: `/v1/rest/goal-config/${id}`,
		method: "put",
		data: data,
	});
};

IndicadoresConfigurationService.del = function (id) {
	return fetch({
		url: `/v1/rest/goal-config/${id}`,
		method: "delete",
	});
};

IndicadoresConfigurationService.sortItems = function (order) {
	return fetch({
		url: `/v1/rest/goal-config/order`,
		method: "put",
		data: order,
	});
};

export default IndicadoresConfigurationService;
